
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/solutions/zero-trust",
      function () {
        return require("private-next-pages/solutions/zero-trust.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/solutions/zero-trust"])
      });
    }
  